import { css } from 'styled-components';
import { ThemedFunctor, BreakpointQueryName } from '@doveit/lego';

export const content: ThemedFunctor = ({
  theme,
  $addCss,
}) => css`
  ${$addCss && $addCss}

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
  }
`;
